import { Box, Container, CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { useState, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';

import { createMuiTheme } from '~/assets/muiTheme/muiTheme';
import { useRootStore } from '~/base/hooks/useRootStore';
import { AuthModal } from '~/base/ui/AuthModal';
import { MFErrorText } from '~/components/reuseable/MFErrorText';
import { i18n } from '~/modules/lang/LangAdapter';
import { LangTypeEnum } from '~/modules/lang/types/Lang';

import MFSurveyForm from '../apps/MFSurveyForm';
import { MFComponentEnum } from '../types/MFTypes';

export const ReactNativeWrapper = () => {
  const { authStore } = useRootStore();

  const [props, setProps] = useState<any>(undefined);

  const searchParams = new URLSearchParams(window.location.search);
  const mfComponent = searchParams.get('component') ?? MFComponentEnum.SURVEY_FORM;

  // Actions

  const postMessage = (data: any) => {
    if (import.meta.env.DEV) {
      console.log('postMessage', data);
    }

    window.ReactNativeWebView?.postMessage(JSON.stringify(data));
  };

  // Effects

  // Имитация передачи данных из WebView
  useEffect(() => {
    if (import.meta.env.PROD) {
      return;
    }

    const { accessToken, refreshToken } = authStore.getTokens();

    window.postMessage(
      JSON.stringify({
        apiUrl: import.meta.env.VITE_APP_API_URL,
        accessToken,
        refreshToken,
        lang: LangTypeEnum.RU,
        theme: {},
      }),
    );

    return () => {};
  }, []);

  useEffect(() => {
    // Обработка сообщения из WebView
    const handleMessage = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data);

        setProps((prevProps: any) => {
          data.theme = createMuiTheme(data.theme, true);

          return { ...prevProps, ...data };
        });

        if (window?.ReactNativeWebView) {
          // Отправляем сообщение в WebView, что компонент инициализирован и готов принимать данные
          setTimeout(() => postMessage({ type: 'READY' }), 0);
        }
      } catch (error) {
        // console.log('Data parsing error: ' + error);
      }
    };

    window.addEventListener('message', handleMessage, true);

    if (window?.ReactNativeWebView) {
      // Отправляем сообщение в WebView, что компонент готов к отображению
      postMessage({ type: 'INITED' });
    }

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // Renders

  if (!props) {
    return <MFErrorText />;
    // return <></>;
  }

  return (
    <I18nextProvider i18n={i18n}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={props.theme}>
          <CssBaseline />

          {mfComponent === MFComponentEnum.SURVEY_FORM && (
            <Container maxWidth="xl" sx={{ bgcolor: '#F5F5F5', minHeight: '100vh' }}>
              <Box py={{ xs: 2, sm: 3 }}>
                <MFSurveyForm
                  isWebView
                  // Base
                  apiUrl={props.apiUrl}
                  tokens={{ accessToken: props.accessToken, refreshToken: props.refreshToken }}
                  onLogout={() => postMessage({ type: 'LOGOUT' })}
                  lang={props.lang}
                />
              </Box>
            </Container>
          )}

          {/* Для разработки в dev mode */}
          {import.meta.env.DEV && <AuthModal />}
        </ThemeProvider>
      </StyledEngineProvider>
    </I18nextProvider>
  );
};
